import React from 'react';
import './Header.css';
import logo from "../assets/airbooked.png";


const Header = ({ onServicesClick, onCaseStudyClick, onPriceClick }) => {


 

  return (
    <>
      <header className="header">
        <img className="logo" src={logo} alt="logo" />

        {/* Desktop Nav */}
       <nav className="nav-main">
     
        <button className="nav-btn-mo" onClick={onServicesClick}>Service</button>
        <button className="nav-btn-mo" onClick={onCaseStudyClick}>Case Study</button>
        <button className="nav-btn-mo" onClick={onPriceClick}>Pricing</button>
    
    </nav>

    

        {/* Hamburger for mobile */}
      

      </header>

     
    </>
  );
};

export default Header;






